export default "__VITE_PUBLIC_ASSET__436e67bb__"